<div class="sticky" [class.prd-sticky]="region === 'prod'">
  <div class="floating-banner">
    <div>
      <h3 class="member-name">
        {{ memberSelected()?.name?.first || '' }} {{ memberSelected()?.name?.last || '' }}
        ({{ memberSelected()?.dependentType ? memberSelected()?.dependentType?.value === "Non-Spouse" ? "Dependent" : "Spouse" : "Subscriber" }})
      </h3>
    </div>
    <div>
      <elig-switch-member [key]="'BMT'" [disabled]="disableSwitchMember()" (selectedMember)="selectedMember($event)">
      </elig-switch-member>
    </div>
  </div>
</div>
<div class="member-details-section">
  @if (showBackToResults()) {
    <div class="back-to-results-row"><button type="button" class="backToTransactions" (click)="goToMemberSearch()">Back To Results</button></div>
  }
  <!-- Client Plan Details Component -->
  <client-plan-details (clientInfo)="onClientInfo($event)" (planDetailsInfo)="onPlanDetailsInfo($event)" [feed]="clientSelected()"
    [loaderImage]="''">
  </client-plan-details>
  @if (clientDetails()) {
    <!-- Family Enrollment Component -->
    <elig-family-enrollment [key]="'BMT'"
      [clientDetailsAgeLimit]="getClientAgeLimit()"
      [subscriberFeed]="subscriberFeed()"
      (headerSelected)="$event === 'Coverage Type' ? scroll('coverage_info') : headerSelectedFromFamilySection($event)" (selectedMember)="selectedMember($event)"
      (addDependent)="headerSelectedFromFamilySection($event)" [loaderImage]="''">
    </elig-family-enrollment>
    <!-- Member info component -->
    <elig-member-info [key]="'BMT'" [selectedAdminPlan]="selectedAdminPlan()"
                      (clientSelected)="transferOrCopyDone($event)"
                       [clientDetails]="$any(clientDetails())"
                      [productDetails]="productDetails()"
                      (headerSelected)="headerSelectedFromMemberInfo($event)"
                      (selectedMemberInfo) = "selectedMember($event)"
                      [loaderImage]="''"
                      [addtionalAttrbituesHeading]="['edit']"
                      [brandLogo]="(clientSelected().planAcronym.toLowerCase() !== 'rlha') ? '../assets/images/logo-delta.svg' : '../assets/images/logo-ren.svg'"
                      [visionLogo]="playerUnderVsp.includes(clientSelected().planAcronym.toUpperCase()) ? '../assets/images/logo-vsp-vision.svg' : ''"
                      [internalApplicationFlow]="true">
    </elig-member-info>
    <elig-coverage-info [key]="'BMT'" id="coverage_info" [loaderImage]="''"></elig-coverage-info>
  }
</div>
